import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProductSection } from './components/ProductSection';
import { PricingSection } from './components/PricingSection';
import { SocialProofSection } from './components/SocialProofSection';
import { FooterSection } from './components/FooterSection';
import { BuyerPopup, StickyCTA } from './components/Overlays';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-white font-sans selection:bg-amber-300 selection:text-slate-900" data-id="element-0" data-mp="2rit1x23ijoou">
      <MetaPixel data-id="element-1" data-mp="2mjpxnjvcxmhx" />
      <HeroSection data-id="element-2" data-mp="31aqeoda66opo" />
      <ProductSection data-id="element-3" data-mp="31b8fzobovt4g" />
      <PricingSection data-id="element-4" data-mp="31bi9hlvy0iew" />
      <SocialProofSection data-id="element-5" data-mp="31c1l6kv02akh" />
      <FooterSection data-id="element-6" data-mp="2wk06ksad07ra" />

      {/* Overlays */}
      <BuyerPopup data-id="element-7" data-mp="2wj8f9tnsow6t" />
      <StickyCTA data-id="element-8" data-mp="2wip6p3k1bk5g" />
    </div>;
}